import React, { FC, useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import SettingsSidebar from '../components/SettingsSidebar'

import { PageLayout, SettingsSwitch } from 'Components'
import { CoreBackendUserReduxType, ReduxStoreState } from 'Models'
import { coreBackendUserSelector, fetchCoreBackendUserAction } from 'ReduxStore/coreBackendUser'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { updateUserSettingsAction } from 'ReduxStore/userSettings'

type SelectorProps = {
  coreBackendUser: CoreBackendUserReduxType
}

const mapStateToProps = createStructuredSelector<ReduxStoreState, SelectorProps>({
  coreBackendUser: coreBackendUserSelector
})

const mapDispatchToProps = {
  fetchCoreBackendUser: fetchCoreBackendUserAction
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const ShowInJournalSettingsPage: FC<PropsFromRedux> = ({ fetchCoreBackendUser }: PropsFromRedux) => {
  const userSettings = useAppSelector((state) => state.userSettings)

  const dispatch = useAppDispatch()

  const toggleSetting = (setting: keyof typeof userSettings.data): void => {
    dispatch(updateUserSettingsAction({ [setting]: !userSettings.data[setting] }))
  }

  useEffect(() => {
    fetchCoreBackendUser()
  }, [])

  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SettingsSidebar />

          <div className="col-12 col-lg-8">
            <h1>Einstellungen</h1>

            <h2 className="mb-3 mt-4">Im Tagebuch anzeigen</h2>

            <div className="basiccard px-3 pt-5 pb-3">
              <SettingsSwitch
                title="Makronährstoffe"
                name="macronutrientsHidden"
                value={!userSettings.data.macronutrientsHidden}
                onValueChange={() => toggleSetting('macronutrientsHidden')}
              />

              <SettingsSwitch
                title="Flüssigkeitszufuhr"
                name="hydrationHidden"
                value={!userSettings.data.hydrationHidden}
                onValueChange={() => toggleSetting('hydrationHidden')}
              />

              <SettingsSwitch
                title="Gemüse und Früchte"
                name="vegetablesAndFruitsHidden"
                value={!userSettings.data.vegetablesAndFruitsHidden}
                onValueChange={() => toggleSetting('vegetablesAndFruitsHidden')}
              />

              <SettingsSwitch
                title="Notizen"
                name="notesHidden"
                value={!userSettings.data.notesHidden}
                onValueChange={() => toggleSetting('notesHidden')}
              />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default connector(ShowInJournalSettingsPage)
